import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    $("body").on("hidden.bs.modal", ".modal", function () {
      $(this).removeData("bs.modal")
    })
  }
}
